<ul class="breadcrumbs">
  @for (
    breadcrumb of breadcrumbsWithHome;
    track breadcrumb;
    let first = $first;
    let last = $last
  ) {
    <li class="breadcrumbs__item">
      @if (!first) {
        <fa-icon
          class="breadcrumbs__icon"
          [icon]="faChevronRight"
          [fixedWidth]="true"
          size="xs"
        ></fa-icon>
      }
      <a
        [routerLink]="['/' + breadcrumb?.pretty_url] | localize"
        [queryParamsHandling]="breadcrumb.queryParamsHandling || null"
        class="breadcrumbs__link"
        [class.breadcrumbs__link--disabled]="last"
        [class.home]="breadcrumb.isHome"
        [title]="breadcrumb?.name | translate"
      >
        @switch (breadcrumb.isHome) {
          @case (true) {
            <span>
              <fa-icon [icon]="faHome" [fixedWidth]="true"></fa-icon>
            </span>
          }
          @default {
            <span>
              {{ breadcrumb.name || breadcrumb.pretty_url }}
            </span>
          }
        }
      </a>
    </li>
  }
</ul>
